import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Home = () => {

  // State to track background image
  const [backgroundImage, setBackgroundImage] = useState('/Home_Page_1.png');
  const [fade, setFade] = useState(false); //To control the fade effect
  const images = ['/Home_Page_1.png', '/Home_Page_2.jpeg']; //Add more images if required
  let imageIndex = 0;

  // Animation variants for the container
  const containerVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { delay: 0.5, duration: 0.5 },
    },
  };

  // Animation variants for interactive elements
  const itemVariants = {
    hover: { scale: 1.05 },
    tap: { scale: 0.95 },
  };

  // Use effect to handle background image change at interval
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(true); // Trigger fade out
      setTimeout(() => {
        imageIndex = (imageIndex + 1) % images.length; // Cycle through images
        setBackgroundImage(images[imageIndex]); // Update background image
        setFade(false); // Trigger fade in
      }, 550); // Delay matches the fade transition duration
    }, 5000); // Change every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <div className="relative min-h-screen flex items-center justify-center text-white p-8">
      {/* Background Image and Gradient Div */}
      <div
        className="absolute inset-0 bg-center bg-cover"
        style={{
          backgroundImage: `linear-gradient(to top, rgba(0, 0, 0, 1.5), rgba(0, 0, 0, 0.1)), url(${backgroundImage})`, // Gradient and background image
          transition: 'background-image 1s ease-in-out', // Smooth transition for background image
        }}
      />

      {/* Dark/Grey Overlay */}
      <div
        className={`absolute inset-0 bg-black transition-opacity duration-1000 ${fade ? 'opacity-60' : 'opacity-0'}`} // Control dark overlay fade
      ></div>

      {/* Content */}
      <motion.div
        className="relative z-10 text-center" // Ensure the content is above the background
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        id="home"
      >
        <motion.h1
          className="text-5xl font-bold mb-4"
          variants={itemVariants}
          whileHover="hover"
          whileTap="tap"
        >
          Empowering Sustainable Growth
        </motion.h1>
        <motion.p
          className="text-xl font-normal mb-6"
          variants={itemVariants}
          whileHover="hover"
          whileTap="tap"
        >
          Unlock your business's potential with eco-friendly solutions.
        </motion.p>
        <motion.div variants={itemVariants} whileHover="hover" whileTap="tap">
          <button className="bg-[#80C32DB2] text-[#ffffff] px-6 py-3 rounded-full font-semibold shadow-lg transition-all transform hover:-translate-y-1">
            Request a Demo
          </button>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Home;